import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Documento } from '../models/documento.model';
import { ConsultaDocumentoDto } from '../dto/consulta-documento.dto';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {
  private _apiUrl = environment.apiUrl + "/v1/Projetos";

  private documentos = new BehaviorSubject<any[]>([]);
  documentos$ = this.documentos.asObservable();

  private loadingSubject = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient) { }

  public get loading() {
    return this.loadingSubject.value;
  }

  // Busca documentos do backend e atualiza o estado local
  carregarProdutos() {
    this.http.get<Documento[]>(this._apiUrl).subscribe((documentos) => {
  
      this.documentos.next(documentos);
    });
  }

  // Adiciona um documentos ao backend e ao estado local
  adicionarDocumento(documento: Documento) {
    this.http.post<Documento>(`${this._apiUrl}/${documento.projetoId}/documentos`, documento).subscribe((novoDocumento) => {
      const listaAtual = this.documentos.getValue();
      this.documentos.next([...listaAtual, novoDocumento]);

      this.atualizarLista(documento.projetoId!);
    });
  }

  /**
   * Edita um documentos no backend e atualiza o estado local
   * @param documentoEditado
   */
  editarDoducmento(documentoEditado: Documento) {
    this.http.put<Documento>(`${this._apiUrl}/${documentoEditado.id}`, documentoEditado).subscribe(() => {
      const listaAtualizada = this.documentos.getValue().map(documento =>
        documento.id === documentoEditado.id ? documentoEditado : documento
      );
      this.documentos.next(listaAtualizada);

      this.atualizarLista(documentoEditado.projetoId!);
    });
  }

  /**
   * Lista de Documentos Vinculados ao Cliente
   */
  consultarDocumentos(projetoId: string): Observable<ConsultaDocumentoDto> {
    this.loadingSubject.next(true);

    return this.http.get<ConsultaDocumentoDto>(`${this._apiUrl}/${projetoId}/documentos`)
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      );
  }

  atualizarProjetoDocumento(projetoId: string, documentoId: string, status: number, tipoDocumento: number): Observable<string> {
    let params = {
      projetoId: projetoId,
      documentoId: documentoId,
      statusDocumento: status,
      tipoDocumento: tipoDocumento
    };


    return this.http.patch<string>(`${this._apiUrl}/${projetoId}/documentos/${documentoId}/status`, params).pipe(
      finalize(() => {
        this.atualizarLista(projetoId);
      })
    )
  }

  atualizarLista(projetoId: string): void {
    this.consultarDocumentos(projetoId).subscribe((dados) => {
      this.documentos.next(dados.documentos); // Atualiza o BehaviorSubject
    });
  }

}
